import { Component, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabComponent<TValue = any, TTemplate = any> {
  @Input() label: string = '';
  @Input() key?: string; // related to TabGroupComponent.initialTabKey
  @Input() value?: TValue = null;
  @Input() template?: TemplateRef<TTemplate>;
  active: boolean = false;
}
